// extracted by mini-css-extract-plugin
export var container = "_h5-1";
export var cornerButtonContainer = "_h5-6";
export var disabled = "_h5-2";
export var dragActive = "_h5-3";
export var fileContainer = "_h5-5";
export var hiddenInput = "_h5-4";
export var widthContainer = "_h5-0";